module.exports = __webpack_public_path__ + "14e261ce7377ae4087f680c9b28b0a51.svg"